import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import { mergeClasses } from '@/utils/style';
import { Text, Headline } from '@/components/typography';
export interface FloatingBoxProps {
  title: string | React.JSX.Element;
  anchorKey?: string;
  content: string | React.JSX.Element;
  image: React.JSX.Element;
  imagePosition?: 'left' | 'right';
  variant?: 'default' | 'small';
}
export function FloatingBox(t0) {
  const $ = _c(30);
  const {
    image,
    imagePosition,
    title,
    anchorKey,
    content,
    variant
  } = t0;
  const ref = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = mergeClasses("relative text-white");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = imagePosition === "right" ? "md:right-52" : "md:left-52";
  const t3 = variant === "small" && "xl:top-[3.75rem] xl:bottom-[3.75rem]";
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = mergeClasses("absolute top-0 right-0 bottom-0 left-0 rounded-2xl bg-blue-800 md:rounded-[2rem]", t2, t3);
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <div className={t4} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = imagePosition === "right" ? "md:pr-0 md:pl-20" : "md:pr-20 md:pl-0";
  const t7 = variant === "small" ? "md:py-4" : "md:py-11";
  let t8;
  if ($[6] !== t6 || $[7] !== t7) {
    t8 = mergeClasses("relative z-10 flex flex-col items-center gap-8 p-4 md:flex-row md:gap-10 lg:gap-20", t6, t7);
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = imagePosition === "right" && "md:order-1";
  let t10;
  if ($[9] !== t9) {
    t10 = mergeClasses("z-10 flex aspect-square w-full max-w-[22rem] shrink-0 items-center justify-center overflow-hidden rounded-xl bg-blue-100 md:rounded-[2rem] lg:max-w-[29.25rem]", t9);
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== image || $[12] !== t10) {
    t11 = <div className={t10}>{image}</div>;
    $[11] = image;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== anchorKey || $[15] !== title) {
    t12 = <Headline as="h3" variant="h4" anchorKey={anchorKey} className="mb-3 md:mb-4">{title}</Headline>;
    $[14] = anchorKey;
    $[15] = title;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = mergeClasses("text-light-gray-100", "[&>a]:text-white!");
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== content) {
    t14 = <Text as="div" variant="p3" className={t13}>{content}</Text>;
    $[18] = content;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t12 || $[21] !== t14) {
    t15 = <div className="pr-2 pb-4 pl-2 md:p-0">{t12}{t14}</div>;
    $[20] = t12;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t11 || $[24] !== t15 || $[25] !== t8) {
    t16 = <div className={t8}>{t11}{t15}</div>;
    $[23] = t11;
    $[24] = t15;
    $[25] = t8;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t16 || $[28] !== t5) {
    t17 = <div ref={ref} className={t1}>{t5}{t16}</div>;
    $[27] = t16;
    $[28] = t5;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
}